import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingPigletPrimaryData, setFootprintingPigletPrimaryDataAdmin } from "services";

import { footprintingPigletPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_AUTOFILL_APPLIED, FOOTPRINTING_PIGLET_PRIMARY_DATA } from "consts";

import { FootprintingPigletPrimaryData } from "models";

export type CreatePigletPrimaryDataQueryParams = {
  autofillYear?: number;
};

export const useMutateFootprintingPigletPrimaryData = (
  farmId: string,
  year: number,
  payload: Partial<Omit<FootprintingPigletPrimaryData, "id">>,
  primaryDataId?: string
) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  const setPrimaryData = isAdmin ? setFootprintingPigletPrimaryDataAdmin : setFootprintingPigletPrimaryData;
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_PIGLET_PRIMARY_DATA, primaryDataId, isAdmin],
      mutationFn: (qps?: CreatePigletPrimaryDataQueryParams) =>
        qps?.autofillYear ? setPrimaryData(payload, primaryDataId, qps) : setPrimaryData(payload, primaryDataId),
      onSuccess: async (_data, variables) => {
        if (variables?.autofillYear) {
          queryClient.setQueryData([FOOTPRINTING_AUTOFILL_APPLIED, "piglet", farmId, year], true);
        }
        invalidateAndRefecthQueries(queryClient, [...footprintingPigletPrimaryQueryKeys(primaryDataId ?? "", farmId, year, isAdmin)]);
      },
    },
    queryClient
  );
};
